import * as React from "react";
import { TTranslate } from "../../../service/locale/TranslationService";
import { FormComponentProps } from "antd/lib/form";
import ReportingPeriodForm from "./ReportingPeriodForm";
import ReportingPeriodPresentationModel, {
  TReportingPeriodPresentationModel
} from "../../../presenter/reporting/model/ReportingPeriodPresentationModel";

export interface State {}

export interface UpdateReportingPeriodFormProps extends FormComponentProps {
  translate: TTranslate;
  registerFormSubmitEventHandler: any;
  rowData: TReportingPeriodPresentationModel;
  codebooks: any;
}

class UpdateReportingPeriodForm extends React.Component<
  UpdateReportingPeriodFormProps,
  State
> {
  componentDidMount() {
    const { registerFormSubmitEventHandler, rowData } = this.props;
    registerFormSubmitEventHandler(e => {
      e.preventDefault();
      let updateReportingPeriodData;
      this.props.form.validateFields((err, values) => {
        if (!err) {
          updateReportingPeriodData = ReportingPeriodPresentationModel(values);
          updateReportingPeriodData.id = rowData.id;
        }
      });
      return updateReportingPeriodData;
    });
  }

  render() {
    const { translate, rowData, codebooks } = this.props;

    const { getFieldDecorator } = this.props.form;

    return (
      <ReportingPeriodForm
        getFieldDecorator={getFieldDecorator}
        translate={translate}
        rowData={rowData}
        codebooks={codebooks}
      />
    );
  }
}

export default UpdateReportingPeriodForm;
